export default {
    printConfig: null,

    /**
     * Initialize Web Printing Service
     */
    async init(printConfig) {
        this.printConfig = printConfig
        return printConfig
    },

    /**
     * Detect Printers
     */
    async detectPrinters() {
        return [];
    },

    /**
     * Send to printer
     *
     * @param printer
     * @param html
     * @param text
     * @param qrCode
     * @param options
     */
    async sendToPrinter(printer, html, text, qrCode, options = {}) {
        return { success: false, error: `Not able to print from web` }
    },

    /**
     * Open printer cash drawer
     */
    openDrawer(printer) {
        console.log('Not able to open cash drawer from web')
    },
};
